import { render, staticRenderFns } from "./ChatFileUploader.vue?vue&type=template&id=e85903d2&scoped=true"
import script from "./ChatFileUploader.vue?vue&type=script&lang=js"
export * from "./ChatFileUploader.vue?vue&type=script&lang=js"
import style0 from "./ChatFileUploader.vue?vue&type=style&index=0&id=e85903d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85903d2",
  null
  
)

export default component.exports